import React, { useEffect, useRef, useState } from "react";
import Select from "react-select";
import { GetServiceCaller } from "../../../../services/serviceCaller";
import { API_URL } from "../../../../constants";
import printJS from "print-js";
import "./printStyles.css"; // Import the print styles
import PaySlipComponent from "../../../../components/PaySlipComponent";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import UAEPaySlipComponent from "../../../../components/UAEPaySlipComponent";
import NICLPaySlipComponent from "../../../../components/NICLPaySlipComponent";
import { useLocation, useParams } from "react-router-dom";

import * as Yup from "yup";
import { FaSpinner } from "react-icons/fa";
const MyPaySlip = () => {
  const location = useLocation();
  const selectedMonth = location.state?.selectedMonth || null;
  const selectedEmp = location.state?.selectedEmp || null;
  const [monthOption, setMonthOption] = useState([]);
  const [monthValue, setMonthValue] = useState(selectedMonth || null);
  const [result, setResult] = useState([]);
  const [response, setResponse] = useState([]);
  const [displayPayslip, setDisplayPaySlip] = useState(0);
  const [shiftID, setShiftID] = useState("");

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("My Payslip"));
    fetchData();
  }, []);
  const fetchData = async () => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}payrolls/payslips-data`
      );

      if (response?.status) {
        const result = response?.data?.data || [];

        const monthOpt = result.map((ele) => ({
          value: ele?.value,
          label: ele?.text,
        }));
        setMonthOption(monthOpt);
      }
    } catch (error) {
      console.error("Fetching Error Data", error);
    }
  };

  useEffect(() => {
    if (selectedMonth) {
      fetchGetData();
    }
  }, [selectedMonth]);
  const [error, setError] = useState(null);

  const validationSchema = Yup.object({
    monthValue: Yup.number().required("Month is required"),
  });

  // Handle month selection change
  const handleMonthChange = async (selectedOption) => {
    setMonthValue(selectedOption.value);
    setError(null);

    try {
      await validationSchema.validate({ monthValue: selectedOption.value });
    } catch (err) {
      setError(err.errors[0]); // Properly set validation error
    }
  };

  const [apiStatus, setApiStatus] = useState("");
  const fetchGetData = async () => {
    // Check if monthValue is null/undefined first
    if (!monthValue) {
      setError("Month selection is required");
      return;
    }

    try {
      setApiStatus(undefined);
      // Validate the selected month
      await validationSchema.validate({ monthValue }, { abortEarly: false });

      setError(null); // Clear any previous errors

      // Proceed with API call
      const response = await GetServiceCaller(
        `${API_URL}payrolls/payslips-pdf?MonthID=${monthValue}&EmployeeID=${
          selectedEmp || ""
        }`
      );

      if (response?.status === 200) {
        setApiStatus(response?.status);
        const result = response?.data?.data || [];
        setResult(result);
        setResponse(response);
        setShiftID(response?.data?.employeeDetails?.[0]?.ShiftId);
        setDisplayPaySlip(1);
      } else {
        setError("Failed to fetch payslip data");
      }
    } catch (error) {
      setApiStatus("");

      if (error instanceof Yup.ValidationError) {
        setError(error.errors[0]);
      } else {
        console.error("API Error:", error);
        setError("An error occurred while fetching data");
      }
    }
  };

  const componentRef = useRef(null);
  const handlePrint = () => {
    printJS({
      printable: "printSection",
      type: "html",
      css: ["index.css"],
      scanStyles: false,
      style: `
      @page { 
        size: auto; 
        margin: 0mm !important; 
      }
      
      body {
        margin: 0 !important;
        padding: 0 !important;
        font-family: 'Source Sans Pro', sans-serif !important;
      }

      #printSection {
        padding: 0 !important;
        margin: 0 !important;
        font-family: 'Source Sans Pro', sans-serif !important;
      }
      * {
      font-family: 'Source Sans Pro', sans-serif !important;
      }
      .no-print {
        display: none !important;
      }
      
      /* General table styles */
      table {
        border-collapse: collapse !important;
        width: 100% !important;
        table-layout: fixed !important;
        margin-bottom: 10px;
        border: 0.5px solid #d3cacaff;
      }
      
      table th, table td {
        border: 0.5px solid #d3cacaff !important;
        text-align: left !important;
        word-wrap: break-word !important;
      }
      
      /* Payroll details table */
      #slipPayroll{
      font-size:12px !important;
      }
      #slipLogoHeader{
        width: 100% !important;
        display: flex !important;
        justify-content: space-between !important;
      }
      #txbdody{
      padding:0px 0px !important;
      font-weight: 700 !important; 
      color: black !important;
      }
      #payrollDetails th, #payrollDetails td {
        padding: 2px 3px !important;
        font-size: 12px !important;
      }
      
      #tablebodyAmount {
        text-align: right !important;
      }

      #totalEarning {
        font-weight: bold !important;
      }
      
      /* Employee details section */
      #payslipTableEmpHeader {
        margin-top: 10px !important;
      }
      #payslipTableHeader > th > h6{
      font-size:22px !important;
      }
      #customHrLine {
      display: block !important;
      visibility: visible !important;
      height: 1px !important;
      background-color: black !important;
      border: none !important;
      padding: 0px !important;
      margin: 10px 0 !important;
      margin-left: auto !important;
      margin-right: 0 !important;
      margin-top: 0 !important;
      margin-bottom: 0 !important;
      width: 52.5% !important;
      -webkit-print-color-adjust: exact !important;
      print-color-adjust: exact !important;
      }

      #slipHeader{
       margin-left:72px !important;
      }
      #slipHeader > h6{
      color:#000 !important;
      font-size:16px !important;
      font-weight:500 !important;
      margin: 0px !important;
      padding: 0px !important;
      font-family: 'Source Sans Pro', sans-serif !important;
      }
      #slipHeader > p{
      color:#000 !important;
      font-size: 16px !important;
      margin: 0px !important;
      padding: 0px !important;
      font-family: 'Source Sans Pro', sans-serif !important;
      }
      #slipHeader > h5{
      color:#000 !important;
      font-size: 12px !important;
      margin: 10px 0px 5px 0px !important;
      padding: 0px !important;
      font-weight:400 !important;
      font-family: 'Source Sans Pro', sans-serif !important;
      }
      #payslipTableEmpHeader td {
        font-size: 12px !important;
        font-weight: normal !important;
      }

      /* Main payslip table adjustments */
      #payslipTable {
        border: transparent !important;
        padding: 0 !important;
        margin-top:10px !important;
      }
      
      #payslipTable th, #payslipTable td {
        border: transparent !important;
        padding: 2px !important;
        margin: 0 !important;
        font-weight: 500 !important;
      }

      #empDetail{
        border: transparent !important;
        padding: 0 !important;
        line-height: 0.9 !important;
        width: 95% !important;
        margin-top: 25px !important;
      }
        #empDetail th, #empDetail td{
        border: transparent !important;
        padding: 0 !important;
        margin: 0 !important;
        font-weight: 500 !important;
        }
        #empDetail tr {
        line-height: 0.9 !important;
        }

        #empDetail td {
        line-height: inherit !important;
        padding: 2px 0 !important;
        }

      /* Footer notes */
      #payableNote {
        margin-top: 10px !important;
        margin-left: -40px !important;
      }
      
      #payableNotes {
        margin-top: 220px !important;
      }
      
      #payableNoteDetails {
        display: flex !important;
        justify-content: center !important;
        text-align: center !important;
        margin-top: 10px !important;
        margin-left: 120px !important;
        font-size: 12px !important;
      }
      
      /* Income slab section */
      #incomeSlab {
        gap: 5px !important;
        display: flex !important;
        margin-top: 5px !important;
        margin-inline: 0px !important;
        width: 100% !important;
      }
      
      #incomeSlableft {
        width: 70% !important;
      }
      
      #incomeSlabright {
        width: 30% !important;
      }
      
      .tbl-heading-tx {
        -webkit-print-color-adjust: exact !important;
        print-color-adjust: exact !important;
        background-color: #d1ecf1 !important;
      }
      
      /* Page break handling */
      .pageBreak {
        page-break-before: always !important;
      }
      
      /* Specific table styles for income calculation */
      .tdBorder {
        border: 0.5px solid #d3cacaff !important;
      }
      
      /* Color styles */
      .bg-white {
        background-color: white !important;
      }
      
      /* Text styles */
      .text-end {
        text-align: right !important;
      }
      
      .m-0 {
        margin: 0 !important;
      }
      
      .font-bold {
        font-weight: bold !important;
      }
      
      /* Responsive adjustments */
      @media print {
        body, #printSection {
          margin: 0 !important;
          padding: 0 !important;
        }
        
        .row {
          display: flex !important;
          flex-wrap: wrap !important;
        }
        
        .col-12 {
          flex: 0 0 100% !important;
          max-width: 100% !important;
        }
        
        .payslip-Card {
          background-color: #27568B !important;
          padding: 35px !important;
        }
        
        /* Ensure proper spacing */
        .h-auto {
          height: auto !important;
        }
        
        /* Make sure tables don't break across pages */
        table {
          page-break-inside: avoid !important;
        }
        
        tr {
          page-break-inside: avoid !important;
        }
      }
      
      /* Additional specific styles from your component */
      .remark-container {
        margin-bottom: 10px !important;
      }
      
      .remark {
        font-style: italic !important;
        font-weight: bold !important;
        margin: 0 !important;
        padding: 0 !important;
      }
      
      .Table-header {
        background-color: #c9d5e2 !important;
      }
      
      .Table-info {
        background-color: #49719e !important;
        color: #fff !important;
      }
      
      .Table-info p {
        font-weight: bold !important;
        margin: 0 !important;
        padding: 6px 3px !important;
        font-size: 12px !important;
      }
      
      /* Ensure proper alignment for IT section tables */
      #itSectionTable {
        width: 100% !important;
        border-collapse: collapse !important;
        margin: 0 !important;
        padding: 0 !important;
        page-break-inside: avoid !important; 
      }
      #slipHeaderInfo{
      font-weight: 700 !important; 
      color: black !important;
      padding: 0px !important; 
      }
        #itSectionTable td:first-child {
        width: 80% !important;
      }
      
      #itSectionTable td:last-child {
        width: 20% !important;
      }
      #itSectionTable td {
        padding: 0px 2px !important;
        font-size: 12px !important;
        font-weight: normal !important;
      }
           #payableNotes {
        position: fixed;
        bottom: 20px;
        width: 100%;
        margin-top: 0 !important;
      }
      
      #payableNote {
        margin-left: 0 !important;
      }
      
      #payableNoteDetails {
        margin-left: 0 !important;
        text-align: center !important;
        width: 100%;
      }
      
      /* Ensure the notes stay on the last page */
      @page :last {
        #payableNotes {
          position: absolute;
          bottom: 0;
        }
      }
    `,
    });
  };
 console.log("shift",shiftID);
 
  return (
    <div className="Container">
      <div id="formOne" className="bg-white mt-2 rounded p-3">
        <div className="row d-flex align-items-center justify-content-center">
          <div className="col-md-3">
            <label className="form-label">Month</label>
            <Select
              options={monthOption}
              value={monthOption?.find((item) => item?.value == monthValue)}
              onChange={(selectedOption) => handleMonthChange(selectedOption)}
            />
            {error && <div className="text-danger">{error}</div>}
          </div>
          <div className="col-md-9 d-flex justify-content-end">
            <div className="mt-0 mt-md-5">
              <button className="custom-btn me-2" onClick={fetchGetData}>
                Get Data
              </button>
              <button className="custom-btn" onClick={handlePrint}>
                Print
              </button>
            </div>
          </div>
        </div>
      </div>
     {apiStatus === undefined ? (
  <div
    className="d-flex justify-content-center align-items-center"
    style={{ height: "50vh" }}
  >
    <div className="text-center">
      <FaSpinner className="spinner spinner-center" />
      <br />
      <p className="mt-2">Loading</p>
    </div>
  </div>
) : apiStatus === 200 ? (
  result == 0 ? (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{ height: "50vh" }}
    >
      No Data Found
    </div>
  ) : displayPayslip === 1 ? (
    shiftID === 6 ? (
      <UAEPaySlipComponent
        result={result}
        response={response}
        componentRef={componentRef}
      />
    ) : shiftID === 7 ? (
      <NICLPaySlipComponent
        result={result}
        response={response}
        componentRef={componentRef}
      />
    ) : (
      <div style={{ overflowX: "auto" }}>
        <PaySlipComponent
          result={result}
          response={response}
          componentRef={componentRef}
        />
      </div>
    )
  ) : null
) : null}
    </div>
  );
};

export default MyPaySlip;
